<ul>
  <li class="flex" *ngFor="let link of options.elements">
    <a [href]="link.href" [ngStyle]="linkItemsStyles">
      {{link.label}}
    </a>
  </li>
</ul>

<ng-container *ipEmailBuilderSettings [ipEmailBuilderHistoryHost]="this | toHistoryOptions">
  <h2 tailH2 i18n="@@add_link">Add Link</h2>
 <div tailPanel>
   <button class="w-full button" tailBtn (click)="addNewLink()" i18n="add_new_link">Add New Link</button>
   <ng-container *ngFor="let link of options.elements; let index = index; let last = last">
    <div class="flex w-full align-items-center gap-2 mt-2">
     <div class="flex flex-col flex-1">
       <label [tailLabel]="item" i18n="@@link_label">Link label</label>
       <input tailInput #item="input" [(ngModel)]="link.label" ipHistoryModel type="text" />
     </div>
      <div class="flex flex-2 align-items-end" style="align-items: end">
        <div style="height: min-content"><button class="w-full" (click)="delete(index)" tailBtn i18n="@@delete">Delete</button></div>
      </div>
    </div>
     <div class="flex flex-col flex-1 mt-2">
       <label [tailLabel]="item" i18n="@@link_label">Link href</label>
       <input tailInput #item="input" [(ngModel)]="link.href" ipHistoryModel type="text" />
     </div>
     <hr class="mt-3 border" *ngIf="!last">
   </ng-container>
 </div>
  <h2 tailH2 i18n="@@font">Font</h2>
  <div tailPanel>
    <h3 tailH3 i18n="@@text_color">Color</h3>
    <tail-color [(value)]="options.color"></tail-color>
    <tail-font class="pt-2" [(value)]="options.font"></tail-font>
    <tail-line-height class="pt-2" [(value)]="options.lineHeight"></tail-line-height>
    <div class="flex flex-col col-span-1 pt-2">
      <label [tailLabel]="i" i18n="@@letter_spacing">Letter Spacing</label>
      <input tailInput #i="input" type="number" [(ngModel)]="options.letterSpacing" ipHistoryModel>
    </div>
    <div class="flex flex-col col-span-1 pt-2">
      <label [tailLabel]="s" i18n="@@text_decoration">Text Decoration</label>
      <select class="appearance-none" tailInput #s="input" [(ngModel)]="options.textDecoration" ipHistoryModel>
        <option *ngFor="let key of textDecorationKeys" [value]="key">
          {{getTextDecorationLabel(key)}}
        </option>
      </select>
    </div>
  </div>
  <h2 tailH2 i18n="@@padding">Padding</h2>
  <div tailPanel>
    <tail-padding [(value)]="options.padding"></tail-padding>
  </div>
  <h2 tailH2 i18n="@@align">Align</h2>
  <div tailPanel class="grid grid-cols-3 gap-2">
    <tail-align class="col-span-2" [(value)]="options.align"></tail-align>
    <button tailBtn (click)="options.hamburger = !options.hamburger"
            [style.box-shadow]="options.hamburger ? '0 2px 2px 3px #f3f3f3' : ''"
            i18n="@@enable_hamburger">
      Enable Hamburger
    </button>
  </div>
</ng-container>
